.footer {
  height: 64px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-top: var(--spacingLg);
  padding-bottom: var(--spacingLg);
  border-top: 1px solid var(--paletteNeutral0);
  box-shadow: 3px -2px 6px rgb(27 72 195 / 0.2);
  background-color: var(--paletteWhite0);
  z-index: 101;
}

.footerContent {
  margin: auto;
  overflow-x: auto;
}

.edgeToEdge {
  padding-left: var(--spacingLg);
  padding-right: var(--spacingLg);
}
